import { fetchAll } from "@/api/rfidreaderdelay";

const state = {
  all: [],
  isLoading: false,
};

const actions = {
  cleanState({ commit }) {
    commit("cleanState");
  },

  async fetchAll({ dispatch, commit }) {
    try {
      dispatch(
        "overlay/show",
        { isShow: true, message: "Carregando RFIDs ..." },
        { root: true }
      );
      const rfidReaderDelay = await fetchAll();

      commit("setAll", rfidReaderDelay);
    } catch (e) {
      dispatch("notify/error", e, { root: true });
    } finally {
      dispatch("overlay/show", false, { root: true });
    }
  },
};

const mutations = {
  setAll(state, rfidReaderDelay) {
    state.all = rfidReaderDelay;
  },

  setLoading(state, isLoading) {
    state.isLoading = isLoading;
  },

  cleanState(state) {
    state.all = [];
    state.isLoading = false;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
